import { Package, Wallet, Users, Crown, Percent, ShoppingBag } from 'lucide-react';
import { cn } from '../lib/utils';

const iconMap = {
  Package: Package,
  Wallet: Wallet,
  Users: Users,
  Crown: Crown,
  Percent: Percent,
  ShoppingBag: ShoppingBag,
};

const CategoryFilter = ({ categories, selectedCategory, onSelectCategory }) => {
  return (
    <div className="flex gap-2 overflow-x-auto pb-2 hide-scrollbar">
      <button
        onClick={() => onSelectCategory(null)}
        className={cn(
          "flex items-center gap-2 px-4 py-2 rounded-full whitespace-nowrap transition-all duration-200",
          selectedCategory === null
            ? "bg-primary text-white shadow-primary"
            : "bg-slate-100 text-slate-700 hover:bg-slate-200"
        )}
        data-testid="category-all"
      >
        <Package className="w-4 h-4" />
        <span className="font-medium text-sm">Todos</span>
      </button>
      
      {categories.map((category) => {
        const Icon = iconMap[category.icon] || Package;
        return (
          <button
            key={category.id}
            onClick={() => onSelectCategory(category.id)}
            className={cn(
              "flex items-center gap-2 px-4 py-2 rounded-full whitespace-nowrap transition-all duration-200",
              selectedCategory === category.id
                ? "bg-primary text-white shadow-primary"
                : "bg-slate-100 text-slate-700 hover:bg-slate-200"
            )}
            data-testid={`category-${category.id}`}
          >
            <Icon className="w-4 h-4" />
            <span className="font-medium text-sm">{category.name}</span>
          </button>
        );
      })}
    </div>
  );
};

export default CategoryFilter;
